module.exports = __webpack_public_path__ + "img/logo.14cdfec9.png";